import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

// eslint-disable-next-line react-refresh/only-export-components
export const validPersonalisationOptions = [
  "{{recipient.firstName}}",
  "{{recipient.lastName}}",
  "{{sender.firstName}}",
  "{{sender.lastName}}",
];

export const PersonalisationDropdown = ({
  className,
  align,
  onSelect,
}: {
  className?: string;
  align?: "start" | "end" | "center";
  onSelect: (item: string) => void;
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" className={className}>
          Personalization <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align}>
        {validPersonalisationOptions?.map((item) => (
          <DropdownMenuItem
            key={item}
            onSelect={() => {
              onSelect(item);
            }}
          >
            {item}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
